import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PromptService } from 'src/app/_services/prompt.service';

@Component({
  selector: 'app-editprompt',
  templateUrl: './editprompt.component.html',
  styleUrls: ['./editprompt.component.css']
})
export class EditpromptComponent implements OnInit {
  submitted=false;
  @Input() label:any;
  constructor( private promptService:PromptService,  private formBuilder:FormBuilder,private activeModal:NgbActiveModal) { }
  definitionForm:FormGroup;
  ngOnInit() {

    this.definitionForm = this.formBuilder.group({
      id: [this.label.id],
      name: [this.label.name],
      systemPrompt: [this.label.systemPrompt, Validators.required],
    });
  }
 

  close(){
    this.activeModal.close();
  }

  save(){
      this.promptService.update(this.definitionForm.value,this.label.id).subscribe(res=>{
          this.activeModal.close();
      });
  }
}
